import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SettingsService } from '../feature/services/settings.service';
import { inject } from '@angular/core';
import Keycloak from 'keycloak-js';

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const settingsService = inject(SettingsService);
  const keycloak = inject(Keycloak);
  
  let apiKey: string | null = null;

  if (req.url.includes('e-komunikacija')) {
    apiKey = settingsService.eKomunikacijeApiKey();
  } else if (req.url.includes('e-ovrhe')) {
    apiKey = settingsService.eOvrheApiKey();
  } else {
    apiKey = keycloak.token!;
  }

  if (apiKey) {
    const clonedRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${apiKey}`,
      },
    });
    return next(clonedRequest);
  }

  return next(req);
}
